<template>
  <div v-if="event">
    <digital-event-preloader type="container" :active="useFullPagePreloader" />

    <div
      id="digital-event-auth"
      class="digital-event-auth-container row"
      :class="[
        event.ADD_LOGIN_BG && event.LOGIN_BACKGROUND_COLOUR
          ? event.LOGIN_BACKGROUND_COLOUR.replace('@', '') + '-bg'
          : 'color-secondary-bg',
        event.ADD_LOGIN_BG && event.LOGIN_BACKGROUND_VIMEO ? 'bg-type-vimeo' : false
      ]"
      :style="
        event.ADD_LOGIN_BG && event.LOGIN_BACKGROUND_TYPE === 'image'
          ? 'background-image: url(' + event.LOGIN_BACKGROUND_IMAGE + ');'
          : false
      "
    >
      <div v-if="event.ADD_LOGIN_BG && event.LOGIN_BACKGROUND_TYPE === 'vimeo'" class="vimeo-wrapper">
        <iframe
          :src="
            'https://player.vimeo.com/video/' +
              event.LOGIN_BACKGROUND_VIMEO +
              '?background=1&muted=1&autoplay=1&loop=1&autopause=0&byline=0&title=0'
          "
          frameborder="0"
          webkitallowfullscreen
          mozallowfullscreen
          allowfullscreen
        ></iframe>
      </div>

      <div v-if="isNotAllowableBrowser" class="browser-support-block-template">
        <h4>Your browser - {{ browserName }} - is not supported.</h4>
        <p>
          Please use <a href="https://www.microsoft.com/edge">Microsoft Edge</a>,
          <a href="https://www.google.com/chrome/">Google Chrome</a> or <a href="https://www.mozilla.org">Firefox</a>
        </p>
      </div>
      <AuthTile v-else>
        <router-view></router-view>
      </AuthTile>
    </div>
  </div>
</template>

<script>
import AuthMixin from "./mixins/AuthMixin";
import CheckBrowserMixin from "../mixins/checkBrowserMixin";
import AuthTile from "./AuthTile";
import { mapState, mapGetters } from "vuex";

export default {
  name: "Auth",
  components: {
    AuthTile
  },
  mixins: [AuthMixin, CheckBrowserMixin],
  computed: {
    ...mapState({
      event: state => state.event.context
    }),
    ...mapGetters(["useFullPagePreloader"])
  },
  async mounted() {
    this.$store.commit("setPreloaderFlag", true);
    if (!this.event) {
      await this.$store.dispatch("event/getContext", {
        includeChildren: 0
      });
    }
    let { messages, errors, user } = await this.$store.dispatch("users/getUser");

    this.showMessages(messages);
    this.showErrors(errors);

    await this.redirectUser(user);

    this.$store.commit("setPreloaderFlag", false);
  }
};
</script>
